import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpurandar() {



  const cardData =
  {
    keyword: 'Cab Service in Purandar',
    heading: 'Sanavi Travels: Cab Service in Purandar',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Purandar, providing safe, comfortable, and convenient transportation for local travel, sightseeing, airport transfers, outstation trips, and corporate travel in and around Purandar. Our fleet of well-maintained hatchbacks, sedans, SUVs, and premium cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free experience. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup and drop across Purandar, Pune, and nearby areas, making it ideal for family trips, business travel, group tours, and religious visits. Choose Sanavi Travels for trusted cab services in Purandar, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Purandar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Purandar Fort",
    "description": "Purandar Fort is a majestic hill fort located in Pune district, steeped in Maratha history. It is famously associated with Chhatrapati Shivaji Maharaj, who used it as a strategic military base. The fort is divided into two parts – Old Purandar and New Purandar – and offers panoramic views of the Sahyadri ranges, valleys, and surrounding villages. Its ancient gates, temples, and bastions attract history enthusiasts, trekkers, and photographers alike."
  },
  {
    "title": "Mahalaxmi Temple at Purandar",
    "description": "The fort complex houses the Mahalaxmi Temple, a spiritual center for devotees. Pilgrims visiting the fort often offer prayers here, combining spiritual exploration with trekking and sightseeing. The temple’s serene ambiance amidst the fort’s historic ruins adds to the cultural richness of the visit."
  },
  {
    "title": "Trekking Routes to Purandar Fort",
    "description": "Purandar Fort is one of the most popular trekking destinations near Pune. Trekkers can choose multiple routes from nearby villages like Saswad, Purandar, and Bhuleshwar. The trails pass through lush greenery, streams, and rocky terrain, making it ideal for adventure enthusiasts and nature lovers."
  },
  {
    "title": "Jafarabad Fort",
    "description": "Located within the Purandar region, Jafarabad Fort is part of the historical network of forts used by the Marathas. It offers a glimpse into military architecture, strategic watchtowers, and panoramic hilltop views that complement the Purandar trekking experience."
  },
  {
    "title": "Purandar Taluka Villages",
    "description": "The villages surrounding Purandar Fort reflect authentic rural Maharashtrian life, with farms, traditional houses, and local markets. Visitors can experience the cultural fabric of the region, local festivals, and farm-to-table cuisine."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "Bhuleshwar Temple, situated near Purandar, is an ancient temple dedicated to Lord Shiva. Its architecture, carvings, and tranquil surroundings attract both devotees and tourists seeking spiritual solace amidst nature."
  },
  {
    "title": "Monsoon Waterfalls",
    "description": "During the monsoon, the Purandar region comes alive with seasonal waterfalls, flowing streams, and mist-covered hills. These natural sights offer refreshing stops during treks and enhance the scenic beauty of the fort and surrounding landscapes."
  },
  {
    "title": "Historical Plaques and Exhibits",
    "description": "Purandar Fort features several plaques, inscriptions, and remnants of Maratha-era architecture, providing historical context for visitors interested in learning about battles, fortifications, and local legends."
  },
  {
    "title": "Sunrise and Sunset Points",
    "description": "The fort’s elevated vantage points offer spectacular sunrise and sunset views. Photographers and travelers alike flock here to capture the golden light over the Sahyadri hills, the valleys below, and the distant villages."
  },
  {
    "title": "Nature Walks and Birdwatching",
    "description": "The forested areas around Purandar Fort are home to a variety of birds and wildlife. Nature enthusiasts can enjoy walks, photography, and birdwatching while exploring the natural beauty surrounding the historic fort."
  }
]
,



"services": [
{
"name": "Cab Service in Purandar",
"description": "Cab Service in Purandar offers reliable and comfortable taxi services for local commuting, sightseeing, and long-distance travel. With well-maintained vehicles, experienced drivers, and flexible booking options, it ensures a smooth and hassle-free journey. Perfect for families, tourists, corporate travelers, and daily commuters, it prioritizes safety, punctuality, and excellent customer service for every trip in and around Purandar."
},
{
"name": "Taxi Service Purandar",
"description": "Taxi Service Purandar provides professional and efficient cab services for city travel, airport transfers, and outstation trips. With transparent pricing, courteous drivers, and timely pickups, it is ideal for residents, tourists, and business travelers seeking dependable and convenient transportation throughout Purandar."
},
{
"name": "AC Cab Purandar",
"description": "AC Cab Purandar ensures a comfortable and refreshing travel experience with fully air-conditioned vehicles. Ideal for long-distance journeys, corporate travel, and family outings, these cabs provide a smooth ride, modern interiors, and a premium travel experience for passengers in Purandar and surrounding areas."
},
{
"name": "Local Cab Purandar",
"description": "Local Cab Purandar offers quick, convenient, and affordable taxi services for intra-city travel, shopping trips, and local sightseeing. With punctual pickups, professional drivers, and well-maintained vehicles, it guarantees a safe, hassle-free, and comfortable journey within Purandar city limits."
},
{
"name": "Outstation Cab Purandar",
"description": "Outstation Cab Purandar specializes in long-distance travel to nearby cities, tourist destinations, and hill stations. Comfortable vehicles, skilled drivers, and flexible itineraries ensure safe, convenient, and enjoyable journeys for families, groups, and solo travelers exploring destinations beyond Purandar."
},
{
"name": "Affordable Cab Purandar",
"description": "Affordable Cab Purandar delivers budget-friendly taxi services without compromising on comfort or safety. Perfect for daily commuters, families, tourists, and corporate groups, it combines economical pricing with professional drivers and well-maintained vehicles, making it a reliable and convenient choice for cost-conscious travelers."
},
{
"name": "Chauffeur Driven Cab Purandar",
"description": "Chauffeur Driven Cab Purandar provides professional drivers who handle navigation, traffic, and schedules efficiently, allowing passengers to relax and enjoy the journey. Ideal for VIP travel, corporate trips, family outings, and tourist excursions, it ensures a stress-free, smooth, and comfortable travel experience."
},
{
"name": "Best Cab Service Purandar",
"description": "Best Cab Service Purandar is known for punctual service, clean and well-maintained vehicles, and excellent customer support. Offering airport transfers, city travel, sightseeing, and outstation trips, it guarantees safe, reliable, and comfortable taxi services for individuals, families, and corporate clients in and around Purandar."
},
{
"name": "Tourist Cab Purandar",
"description": "Tourist Cab Purandar caters to travelers exploring Purandar and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a memorable sightseeing experience, allowing tourists to enjoy cultural, historical, and scenic sites without worrying about logistics or navigation."
},
{
"name": "Airport Cab Purandar",
"description": "Airport Cab Purandar offers timely and convenient taxi services for airport pickups and drop-offs. Professional drivers, well-maintained vehicles, and real-time scheduling ensure passengers reach the airport comfortably and on time, making it a reliable choice for domestic and international travelers."
},
{
"name": "Corporate Cab Purandar",
"description": "Corporate Cab Purandar provides professional taxi services for executives, office travel, meetings, and corporate events. With punctual pickups, experienced drivers, and clean vehicles, it ensures efficient, reliable, and stress-free transportation for business purposes in Purandar and nearby areas."
},
{
"name": "Online Cab Booking Purandar",
"description": "Online Cab Booking Purandar allows travelers to reserve cabs quickly and conveniently with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make trip planning easy, hassle-free, and convenient for tourists, corporate clients, and local commuters alike."
},
{
"name": "Family Cab Purandar",
"description": "Family Cab Purandar provides spacious, safe, and comfortable vehicles suitable for family travel. Designed to accommodate all age groups, it ensures smooth and enjoyable journeys for family outings, vacations, and day trips within Purandar and surrounding areas."
},
{
"name": "24x7 Taxi Purandar",
"description": "24x7 Taxi Purandar offers round-the-clock taxi services for emergency travel, late-night pickups, airport transfers, and unplanned trips. With reliable drivers, well-maintained vehicles, and instant availability, it ensures passengers can travel safely and comfortably at any hour of the day or night."
},
{
"name": "Purandar Travel Taxi",
"description": "Purandar Travel Taxi provides comprehensive cab services for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, and corporate travelers seeking dependable and convenient transportation in Purandar and nearby areas."
}
],
"tableData": [
["Cab Service in Purandar", "Taxi Service Purandar"],
["AC Cab Purandar", "Local Cab Purandar"],
["Outstation Cab Purandar", "Affordable Cab Purandar"],
["Chauffeur Driven Cab Purandar", "Best Cab Service Purandar"],
["Tourist Cab Purandar", "Airport Cab Purandar"],
["Corporate Cab Purandar", "Online Cab Booking Purandar"],
["Family Cab Purandar", "24x7 Taxi Purandar"],
["Purandar Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Purandar with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Purandar for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and kept clean to ensure a smooth and pleasant ride throughout Purandar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Purandar routes, ensuring safe, timely, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Purandar, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Purandar."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Purandar?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Purandar for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Purandar?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Purandar?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Purandar.'
  },
  {
    question: 'Are the drivers experienced with routes in Purandar?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Purandar area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Purandar.'
  },
  {
    question: 'Is the cab service in Purandar available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Purandar to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Purandar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Patil',
    feedback: 'Booked a cab in Purandar with Sanavi Travels — excellent service, clean cab, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Shinde',
    feedback: 'Great cab experience in Purandar with prompt pickup and comfortable ride. Highly recommended!',
    rating: 5
  }
];




















































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Cab Service in Purandar - Sanavi Travels",
  "description": "Sanavi Travels offers reliable cab services in Purandar for local rides, outstation trips, airport transfers, corporate travel, family trips, and tourist travel. AC and chauffeur-driven cabs available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "42"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Cab Service in Purandar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book reliable cab service in Purandar with Sanavi Travels. AC and chauffeur-driven taxis available for local, outstation, airport, corporate, family, and tourist travel. 24x7 online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/141.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinpurandar;